<template>
  <section>
    <app-header icon="clipboard" title="Agenda" />
    <div class="flex_schedule">
      <FirstContainer
        ref="firstContainerRef"
        :selectedDate="currentDate"
        @onSelectDate="(date) => onSelectDate(date)"
        @onSelectDoctor="(doctorId) => (selectedDoctorId = doctorId)"
        @onSelectLocation="(locationId) => (selectedLocationId = locationId)"
        @onSelectHealthPlan="
          (healthPlanId) => (selectedHealthPlanId = healthPlanId)
        "
        @onSelectProcedure="(procedureId) => (selectedProcedureId = procedureId)"
      />

      <SecondContainer
        ref="secondContainerRef"
        :date="selectedDate.date"
        :events="selectedDate.events"
        :doctorId="selectedDoctorId"
        :locationId="selectedLocationId"
        :healthPlanId="selectedHealthPlanId"
        :procedureId="selectedProcedureId"
        @onChangeCurrentDay="(day) => (currentDate = day)"
        @onNewScheduleClick="(event) => (newEventDetails = event)"
        @selectedEvent="(event) => (selectedEvent = event)"
      />

      <ThirdContainer
        v-if="showThirdContainer"
        :doctorId="selectedDoctorId"
        :schedule="selectedEvent"
        :newSchedule="newEventDetails"
        :healthPlanId="selectedHealthPlanId"
        :procedureId="selectedProcedureId"
        :addressId="selectedLocationId"
        @close="() => onReloadEvents(false)"
        @reloadEvents="() => onReloadEvents()"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.flex_schedule {
  display: flex;
  gap: 25px;
}
</style>

<script>
import MonthCalendar from '@/components/schedule/MonthCalendar.vue';
import DayCalendar from '@/components/schedule/DayCalendar.vue';
import ScheduleContainer from '@/components/schedule/ScheduleContainer.vue';

export default {
  components: {
    FirstContainer: MonthCalendar,
    SecondContainer: DayCalendar,
    ThirdContainer: ScheduleContainer,
  },
  data: () => ({
    selectedDate: {},
    newEventDetails: null,
    selectedEvent: null,
    selectedDoctorId: null,
    selectedLocationId: null,
    currentDate: new Date(),
    selectedHealthPlanId: null,
    selectedProcedureId: null,
  }),
  watch: {
    currentDate() {
      this.selectedEvent = null;
      this.newEventDetails = null;
    },
  },
  computed: {
    showThirdContainer() {
      return this.selectedEvent || this.newEventDetails;
    },
  },
  methods: {
    onSelectDate(date) {
      this.selectedDate = date;
      this.newEventDetails = null;
      this.selectedEvent = null;
    },
    onReloadEvents(reload = true) {
      this.selectedEvent = null;
      this.newEventDetails = null;

      if (reload) {
        this.$refs.firstContainerRef.loadDoctorEvents();
        this.$refs.secondContainerRef.loadAvailableHours();
      }
    },
  },
};
</script>
